import { render, staticRenderFns } from "./TwoColumnsBoxed.vue?vue&type=template&id=826ba1ba&"
import script from "./TwoColumnsBoxed.vue?vue&type=script&lang=js&"
export * from "./TwoColumnsBoxed.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnsBoxed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports